var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from '@apollo/client';
import ORGANIZATION_GROUPS from 'apollo/queries/ORGANIZATION_GROUPS';
import { useSafeRunMutation } from 'utils/mutations';
// TEAM_UPDATE_ORGANIZATION_GROUPS
export var mutation = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation TeamUpdateOrganizationGroups(\n    $add_ids: [ID!]\n    $team_id: ID!\n    $remove_ids: [ID!]\n  ) {\n    teamUpdateOrganizationGroups(\n      add_ids: $add_ids\n      team_id: $team_id\n      remove_ids: $remove_ids\n    ) {\n      added {\n        id\n      }\n    }\n  }\n"], ["\n  mutation TeamUpdateOrganizationGroups(\n    $add_ids: [ID!]\n    $team_id: ID!\n    $remove_ids: [ID!]\n  ) {\n    teamUpdateOrganizationGroups(\n      add_ids: $add_ids\n      team_id: $team_id\n      remove_ids: $remove_ids\n    ) {\n      added {\n        id\n      }\n    }\n  }\n"])));
export default function useTeamUpdateOrganizationGroupsMutation(variables) {
    var _a = useSafeRunMutation({
        mutation: mutation,
        responsePath: 'teamUpdateOrganizationGroups',
        successMessage: 'Team organization groups updated',
        refetchQueries: [{ query: ORGANIZATION_GROUPS, variables: variables }]
    }), onMutate = _a.onMutate, loading = _a.loading;
    return { onMutate: onMutate, loading: loading };
}
var templateObject_1;
